import type { DoorThreadRead } from '../../services/qcpInvestigations';
import { primaryRef } from './caseIdentity';
import { caseForThread } from './qualityWorkspaceView';
import { useQualityTriage } from './qualityTriageContext';

/** A list row's one identifier for a thread (proposal 6): its case's INV-
 *  number once the shell's poll has the case, its QT- number before that. */
export function ThreadRefLabel({ thread }: { thread: DoorThreadRead }) {
  // Optional chaining: rows rendered outside the shell (tests) have no context.
  const investigations = useQualityTriage()?.invState?.investigations ?? [];
  return <>{primaryRef(thread, caseForThread(investigations, thread)).label}</>;
}
